export type AtsRole = 'admin' | 'coordinator' | 'recruiter' | 'manager';

export const isAtsAvailable = (company?: { atsEnabled?: boolean | null } | null): boolean => (
  company?.atsEnabled === true
);

export const isRelevanterAvailable = (
  company?: { relevanterEnabled?: boolean | null } | null,
): boolean => company?.relevanterEnabled !== false;

export const getAtsBaseUrl = (): string => (
  process.env.REACT_APP_ATS_BASE_URL || 'http://127.0.0.1:8011/api/v1'
).replace(/\/+$/, '');

export const mapAtsRole = (role: unknown): AtsRole => {
  const normalized = String(role || '').toUpperCase();
  if (normalized === 'SUPER_ADMIN' || normalized === 'ADMIN' || normalized === 'OWNER') return 'admin';
  if (normalized === 'COORDINATOR') return 'coordinator';
  if (normalized === 'RECRUITER') return 'recruiter';
  return 'manager';
};
